<template lang="pug">
  #app-conversas-assunto
    el-card(shadow="hover")
      p.bolder Filtros
      el-row.margin-left
        el-col(:xs="12" :lg="7" :xl ="7" :sm="13")
          InputEntreDatas(
            placeholder="Período"
            :calendario="calendario"
            v-model="calendario"
          )
        el-col(:xs="24" :lg="6" :xl ="8" :sm="11")
          p Status
          el-select(
            v-model="filtro.status"
            multiple
            collapse-tags
            filterable
            clearable
          )
            el-option(
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
        el-col(:xs="24" :lg="9" :xl ="8" :sm="13")
          p Assunto
          el-select(
            style="width: 24rem"
            v-model="filtro.assunto"
            multiple
            collapse-tags
            filterable
            clearable
          )
            el-option(
              v-for="item in assuntos"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
      el-row.margin.float
        el-button(
          type="text"
          size="medium"
          round
          @click="handleLimpar"
        ) Limpar
        el-button(
          type="primary"
          size="medium"
          round
          @click="handleFiltrar"
        ) Filtrar
    el-card(shadow="hover")#graficoId.content-dados
      GraficoResponsavel(
        v-if="acaoCondicao"
        :dadosLabels="dadosFiltro"
      )
      app-listagem-conversas.custom-tabela(
        v-else
        :data="dadosFiltro"
        :colunaChave="nomeColuna"
        :totalDeConversas="totalDeConversas"
        emptyData = "Não há dados registrados"
      )
    el-row
      BotaoSelecionar.center(
        @btn-0="selecionar('acao-1')"
        @btn-1="selecionar('acao-2')"
        botao0="Gráficos"
        botao1="Tabela"
      )
    el-row.botao-exportar.float
      BotaoExportarSelecionado(
        @exportar-img-grafico="exportarImgGrafico"
        :dadosFiltro="filtro"
        :selecionadoCondicao="acaoCondicao"
        :disabled="botaoExportarDesligado"
        tab="responsavel"
        :carregando="isLoading"
      )
</template>

<script>
import { mapActions } from 'vuex'
import domtoimage from 'dom-to-image'
import moment from 'moment'

import AppNotificacao from '@/components/mixins/AppNotificacao'
import InputEntreDatas from '../InputEntreDatas'
import BotaoSelecionar from '../BotaoSelecionar'
import GraficoResponsavel from '../graficos/GraficoResponsavel'
import BotaoExportarSelecionado from '../BotaoExportarSelecionado'
import AppListagemConversas from '../AppListagemConversas'
import { status, assuntos } from './nomesEstaticos'

export default {
  name: 'AppConversasResponsaveis',
  mixins: [
    AppNotificacao
  ],
  components: {
    InputEntreDatas,
    AppListagemConversas,
    BotaoSelecionar,
    BotaoExportarSelecionado,
    GraficoResponsavel
  },

  data () {
    return {
      calendario: [],
      status: [],
      assuntos: [],
      nomeColuna: 'Responsável',
      acaoCondicao: true,
      totalDeConversas: 0,
      responsaveis: [],
      dadosFiltro: [],
      isLoading: false,
      botaoExportarDesligado: false,
      filtro: {
        dataInicio: null,
        dataFim: null,
        status: [],
        assunto: []
      },
      colunasTabela: [
        { key: 'STATUS', label: 'Status' },
        { key: 'QUANTIDADE', label: 'Quantidade' }
      ]
    }
  },

  methods: {
    ...mapActions({
      filtrarPorResponsaveis: 'filtros/filtrarPorResponsavel'
    }),

    selecionar (acao) {
      if (acao === 'acao-1') {
        this.acaoCondicao = true
      } else {
        this.acaoCondicao = false
      }
    },

    handleLimpar () {
      this.calendario = null
      this.filtro = {
        dataInicio: null,
        dataFim: null,
        status: [],
        assunto: []
      }
      this.getFiltroResponsaveis().then(() => this.seNaoHaDados())
    },

    exportarImgGrafico () {
      this.isLoading = true
      const dataConsulta = moment().format('DD-MM-YYYY_hh:mm:ss')
      domtoimage.toBlob(document.getElementById('graficoId'))
        .then(blob => {
          window.saveAs(blob, `Gráfico_Responsavel_${dataConsulta}.png`)
          this.isLoading = false
        })
    },

    seNaoHaDados () {
      if (this.dadosFiltro.every(elem => elem.quantidade === 0)
      ) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Nenhuma conversa encontrada neste período.')
        this.botaoExportarDesligado = true
      } else {
        this.botaoExportarDesligado = false
      }
    },

    async handleFiltrar () {
      if (
        this.calendario <= 0 &&
        this.filtro.status <= 0 &&
        this.filtro.assunto <= 0
      ) {
        this.dadosFiltro = await this.filtrarPorResponsaveis()
        this.seNaoHaDados()
      } else if (
        this.calendario <= 0 &&
        !this.filtro.status <= 0 &&
        !this.filtro.assunto <= 0
      ) {
        this.dadosFiltro = await this.filtrarPorResponsaveis(this.filtro)
        this.seNaoHaDados()
      } else {
        this.filtro.dataInicio = moment(this.calendario[0]).format('yyyy-MM-DD')
        this.filtro.dataFim = moment(this.calendario[1]).format('yyyy-MM-DD')
        this.dadosFiltro = await this.filtrarPorResponsaveis(this.filtro)
        this.seNaoHaDados()
      }
      let totalFiltrado = 0
      for (let i = 0; i < this.dadosFiltro.length; i++) {
        totalFiltrado += this.dadosFiltro[i].quantidade
      }
      this.totalDeConversas = totalFiltrado
      if (this.totalDeConversas === 0) {
        this.dadosFiltro = []
      }
    },

    async getFiltroResponsaveis () {
      this.totalDeConversas = 0
      this.dadosFiltro = await this.filtrarPorResponsaveis()
      for (let i = 0; i < this.dadosFiltro.length; i++) {
        this.totalDeConversas += this.dadosFiltro[i].quantidade
      }
    }
  },

  created () {
    this.assuntos = assuntos
    this.status = status
  },

  mounted () {
    this.getFiltroResponsaveis()
  }
}
</script>

<style lang="scss" scoped>

  .margin {
    margin: 1.5rem 2rem 1.5rem;
  }

  .margin-left {
    margin-left: 0.3rem;
  }

  .float {
    float: right;
  }

  .center {
    display:flex;
    position:absolute;
    left: auto;
    right: 45%;
    top: -1.3rem;
  }

  .bolder {
    font-weight: bolder;
  }

  .content-dados {
    margin-top: 1rem ;
    height: 24rem;
    width: 100%;
  }

  /deep/ .cell {
    color: #424242;
  }

  .botao-exportar {
    margin: 1.5rem 2rem 0.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/components/conversas/AppConversasResponsavel.vue